/**
 * The one date format the Followers screen prints, "Nov 1, 2026", in the
 * device's own time zone (profile rule 6). Built once at module level: a
 * formatter per row is the allocation pattern ISSUE-1136 bans.
 */
const FOLLOW_DATE_FORMAT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

export function formatFollowDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return FOLLOW_DATE_FORMAT.format(date);
}

export function requestedOnLine(iso: string): string {
  const date = formatFollowDate(iso);
  return date === "" ? "" : `Asked ${date}`;
}

export function followsYouSinceLine(iso: string): string {
  const date = formatFollowDate(iso);
  return date === "" ? "" : `Follows you since ${date}`;
}

export function followingSinceLine(iso: string): string {
  const date = formatFollowDate(iso);
  return date === "" ? "" : `Following since ${date}`;
}

export function requestSentLine(iso: string): string {
  const date = formatFollowDate(iso);
  return date === "" ? "" : `Requested ${date}`;
}
